import axios from 'axios';
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import { useLoading } from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

//1) create an axios instance
const axiosGtalento = axios.create({
    //baseURL: 'http://localhost:8000/',
    headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
    }
});

// Initialize loading overlay
const $loading = useLoading({
    // Optional: You can pass default props here
    color: '#f8760cff',
    loader: 'bars',
    width: 64,
    height: 64,
    backgroundColor: '#ffffff',
    opacity: 0.5,
    zIndex: 2999,
});

let activeRequests = 0;
let loader = null;

//2) request interceptor
axiosGtalento.interceptors.request.use((config) => {
    // Get the token from localStorage
    const token = localStorage.getItem('access_token');

    // If the token exists, set it in the Authorization header
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Show loading overlay
    activeRequests++;
    if (activeRequests === 1 && !loader) {
        loader = $loading.show({
            container: null, // null = full page
            canCancel: false,
            onCancel: () => {},
        });
    }

    return config;
}, (error)=>{
    // Handle request error
    activeRequests--;
    if (activeRequests === 0 && loader) {
        loader.hide();
        loader = null;
    }
    return Promise.reject(error);
});

//3) response interceptor
axiosGtalento.interceptors.response.use((response) => {
    const toast = useToast();

    // Hide loading overlay
    activeRequests--;
    if (activeRequests === 0 && loader) {
        loader.hide();
        loader = null;
    }

    /*
    GTALENTO: custom message from back-end formats.
    response-SUCCESS-new-format: response.data?.message; --> laravel-controller-method:  return response()->json(["success" => true, "message" => 'Exito listado lugar de nacimiento.',  "showFrontend" => true], 200);
    response-SUCCESS-old-format: response.data?.mensaje; --> laravel-controller-method:  return response()->json(["code" => 200, "mensaje" => " EXITO custom-message-from-backend", "showFrontend" => true,...], 200);
    */
    if(
        (response.data?.success === true && response.data?.showFrontend && response.data.showFrontend === true ) || //new response-format (recommended)
        (response.data?.code && response.data?.code === 200 && response.data?.showFrontend && response.data.showFrontend === true ) || //old format
        (response.data?.codigoRespuesta && response.data?.codigoRespuesta === 200 && response.data?.showFrontend && response.data.showFrontend === true )
    )
    {
        const backendMessage = response.data?.message || response.data?.mensaje || 'Operación exitosa.'
        toast.open({
            type: 'success',
            position: 'top-right',
            message: backendMessage,
            duration: Number(response.data?.duration) || 2000,
            dismissible: true,
            queue: false
        });
    }
    return response;
}, (error) =>{
    const toast = useToast();

    // Hide loading overlay
    activeRequests--;
    if (activeRequests === 0 && loader) {
        loader.hide();
        loader = null;
    }

    /*
    GTALENTO: custom message from back-end formats.
    response-error-new-format: error.response?.data?.message; --> laravel-controller-method:  return response()->json(["message" => $e->getMessage()], 500);  OR do not use try-catch.
    response-error-old-format: error.response?.data?.mensaje; --> laravel-controller-method:  return response()->json(["code" => 500, "mensaje" => "custom-message-from-backend",...], 500);
    */
    const errorMessage = error.response?.data?.message || error.response?.data?.mensaje || error.message || 'Error desconocido.';
    // Handle response error
    if (error.response && error.response.status === 401) {
        // If the user is unauthorized, redirect to the login page
        //window.location.href = '/login';
    } else if (error.response && error.response.status === 404) {
        // If the user is forbidden, show a specific message
        toast.open({
            type: 'warning',
            position: 'top-right',
            message: errorMessage || 'Recurso no encontrado.',
            duration: 7000,
        });
    } else {
        toast.open({
            type:'error',
            position: 'top-right',
            message: errorMessage,
            duration: 10000,
            dismissible: true,
            queue: false
        });
    }
    return Promise.reject(error);
});

export { axiosGtalento };